/**
 * This wraps tables inside a div, which allows us to overflow the table
 * when the screen size gets too small
 */
const tables = Array.from(document.querySelectorAll('table'));
tables.forEach((table) => {
    table.insertAdjacentHTML('afterend', `
        <div class="table"></div>
    `);
    table.nextElementSibling.appendChild(table);
});



// WEBPACK FOOTER //
// ./app/scripts/components/tables.js